import { Alert, Snackbar as MuiSnackbar } from '@mui/material';
import { useToastStore } from '../stores/toast.store';

/**
 * Snackbar global controlado pelo `useToastStore`. Mostra um toast por vez
 * (FIFO): o primeiro da fila aparece; ao fechar, o próximo entra.
 */
export function Snackbar(): JSX.Element | null {
  const current = useToastStore((s) => s.toasts[0]);
  const dismiss = useToastStore((s) => s.dismiss);

  if (!current) return null;

  return (
    <MuiSnackbar
      key={current.id}
      open
      autoHideDuration={current.durationMs}
      onClose={(_, reason) => {
        if (reason === 'clickaway') return;
        dismiss(current.id);
      }}
      anchorOrigin={{ vertical: 'bottom', horizontal: 'center' }}
    >
      <Alert
        severity={current.severity}
        variant="filled"
        onClose={() => dismiss(current.id)}
        sx={{ width: '100%' }}
      >
        {current.message}
      </Alert>
    </MuiSnackbar>
  );
}
